<div class="slider-book-clubs">
  <app-record-slider
    [items]="swiperItems"
    [userSlider]="true"
    [selectedItemIndex]="selectedItemIndex"
    [showSwiperButtons]="swiperItems.length >= 7"
    (indexClicked)="onSelected($event, swiperItems[$event])">
    <ng-template appSliderTitle>
      <h2 tabindex="0">{{ title }}</h2>
    </ng-template>
  </app-record-slider>
</div>
